import React, {Component} from "react";

import {RTPProfilesFilterSelected} from "./RTPProfileConfigurationSection.component";

interface RTPProfilesSearchProps {
    settings: any[];
    selectedFilters: RTPProfilesFilterSelected;
    searchAction: any;
}

interface RTPProfilesSearchState {
    isFocused: boolean;
    searchValue: string;
}

class RTPProfilesSearch extends Component<
    RTPProfilesSearchProps,
    RTPProfilesSearchState
> {
    searchInput: React.RefObject<HTMLInputElement> = React.createRef();
    searchContainer: React.RefObject<HTMLDivElement> = React.createRef();

    state = {
        isFocused: false,
        searchValue: ""
    };

    componentDidMount() {
        document.addEventListener("click", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
    }

    handleClickOutside = event => {
        if (
            this.searchContainer.current &&
            !this.searchContainer.current.contains(event.target)
        ) {
            this.setState({isFocused: false});
        }
    };

    onSelectGame = event => {
        this.props.searchAction(event.currentTarget.getAttribute("data-value"));
        if (this.searchInput.current) {
            this.searchInput.current.value = "";
        }
        this.setState({searchValue: "", isFocused: false});
    };

    onInput = event => {
        this.setState({searchValue: event.target.value});
    };

    render() {
        const searchValue = this.state.searchValue.toUpperCase();
        const games = this.props.settings.filter(
            setting =>
                setting.description.toUpperCase().includes(searchValue) &&
                !this.props.selectedFilters.selectedGames.includes(
                    setting.description
                )
        );

        return (
            <div
                ref={this.searchContainer}
                className="filter-select search-games"
            >
                <input
                    ref={this.searchInput}
                    onFocus={() => this.setState({isFocused: true})}
                    onInput={this.onInput}
                    placeholder="Search Games"
                />
                {this.state.isFocused && (
                    <div className="search-results">
                        <div>
                            <span>Games</span>
                            <ul>
                                {games.map(setting => (
                                    <li
                                        onClick={this.onSelectGame}
                                        key={setting.identifier}
                                        data-value={setting.description}
                                    >
                                        {setting.description}
                                    </li>
                                ))}
                                {games.length === 0 && <li>No Results</li>}
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default RTPProfilesSearch;
